/*
 * @Descripttion: 
 * @version: 
 * @Author: yanghui
 * @Date: 2021-10-27 17:07:30
 * @LastEditors: yanghui
 * @LastEditTime: 2021-10-28 18:13:18
 */
/**
 * Created by lk on 17/6/4.
 */
 import axios from "../../utils/axios";

 // 获取列表
 export function getListApi(data) {
     return axios({
         url: "/hfIntegralGiftLogManage/getList",
         method: "post",
         data: data
     });
 }
 
 // 获取专属客服
 export function getUserListApi(query) {
  return axios({
      url: "/hfIntegralGiftLogManage/getUserList",
      method: "get",
      params: query
  });
}

// 导出详情
export function exportOrderDetailApi(query) {
  return axios({
      url: "/hfIntegralGiftLogManage/exportOrderDetail",
      method: "get",
      params: query
  });
}



 // 获取礼品详情
 export function getDetailsApi(query) {
  return axios({
      url: "/hfIntegralGiftLogManage/getDetails",
      method: "get",
      params: query
  });
}

//礼品订单修改
export function updateApi(data) {
  return axios({
      url: "/hfIntegralGiftLogManage/update",
      method: "post",
      data: data
  });
}

//取消订单
export function cancelApi(query) {
  return axios({
      url: "/hfIntegralGiftLogManage/cancel",
      method: "post",
      params: query
  });
}


//发货
export function sendApi(query) {
  return axios({
      url: "/hfIntegralGiftLogManage/send",
      method: "post",
      params: query
  });
}



 
 // 获取角色列表
 export function authAdminRoleList(query) {
     return axios({
         url: "/admin/roleList",
         method: "get",
         params: query
     });
 }
 
 // 保存
 export function authAdminSave(data, formName, method = "post") {
     let url = formName === "add" ? "/admin/save" : "/admin/edit";
     return axios({
         url: url,
         method: method,
         data: data
     });
 }
 
 // 删除管理员
 export function authAdminDelete(data) {
     return axios({
         url: "/admin/delete",
         method: "post",
         data: data
     });
 }
 